module.exports = __webpack_public_path__ + "img/e_2_15_g.5b2d8e41.png";